import React, { useEffect, useState } from "react";
import { useDataProvider } from "../../api/DataProvider";
import "../../styles/devices/mob_SignDialog.css";
import Chip from '@mui/material/Chip';

import Paper from "@mui/material/Paper";
import Link from "@mui/material/Link";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function Dialog_content_more(props) {
  const { dialogPosition, handleClickChangeLemma, handleClickChangeLemmaByGloss } = props;
  const { json_data_lemma, json_data_meaning, json_data_glosses } = useDataProvider();
  const [state, setState] = useState(false);
  const [showMore, setShowMore] = useState({ arr_comments: false, arr_lemmas: false, arr_relatedTo: false, arr_equalTo: false, arr_similarTo: false });
  const [dataMore, setDataMore] = useState({ arr_comments: [], arr_lemmas: [], arr_relatedTo: [], arr_equalTo: [], arr_similarTo: [] });

  const handleClickOpenURL = (url) => () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    setShowMore({
      arr_comments: json_data_meaning[dialogPosition["meaning"]]["arr_comments"].length > 0,
      arr_lemmas: json_data_meaning[dialogPosition["meaning"]]["arr_lemmas"].length > 1,
      arr_relatedTo: json_data_meaning[dialogPosition["meaning"]]["arr_relatedTo"].length > 0,
      arr_equalTo: json_data_glosses[dialogPosition["gloss"]] !== undefined ? json_data_glosses[dialogPosition["gloss"]]["arr_equalTo"].length > 0 : false,
      arr_similarTo: json_data_glosses[dialogPosition["gloss"]] !== undefined ? json_data_glosses[dialogPosition["gloss"]]["arr_similarTo"].length > 0 : false,
    });
    setState(false);
  }, [dialogPosition]);

  useEffect(() => {
    setDataMore({
      arr_comments: showMore['arr_comments'] ? json_data_meaning[dialogPosition["meaning"]]["arr_comments"] : [],
      arr_lemmas: showMore['arr_lemmas'] ? json_data_meaning[dialogPosition["meaning"]]["arr_lemmas"] : [],
      arr_relatedTo: showMore['arr_relatedTo'] ? json_data_meaning[dialogPosition["meaning"]]["arr_relatedTo"] : [],
      arr_equalTo: showMore['arr_equalTo'] ? json_data_glosses[dialogPosition["gloss"]]["arr_equalTo"] : [],
      arr_similarTo: showMore['arr_similarTo'] ? json_data_glosses[dialogPosition["gloss"]]["arr_similarTo"] : [],
    });
  }, [showMore]);

  return (
    <>
      {showMore["arr_comments"] === true || showMore["arr_lemmas"] === true || showMore["arr_relatedTo"] === true || showMore["arr_equalTo"] === true || showMore["arr_similarTo"] === true ? (
        <Accordion className='sig_SignModal_MoreInfoContainer' expanded={state} onChange={() => setState((state) => !state)}>
          <AccordionSummary className='sig_SignModal_MoreInfoButton' expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">MÁS INFORMACIÓN</AccordionSummary>
          <AccordionDetails>
            {showMore["arr_comments"] ? (
              <Paper className="sig_SignModal_PaperContent">
                <div className="sig_SignModal_PaperTitle">Información relacionada</div>
                <hr></hr>
                <div className="sig_SignModal_PaperBody">
                  {dataMore["arr_comments"].map((item, index) => {
                    const text = item["label"];
                    const url = item["url"];
                    return (
                      <>
                        {url !== "" ? (
                          <>
                            <li key={index}>
                              <Link component="button" variant="body2" onClick={handleClickOpenURL(url)}>
                                {" "}
                                {text}{" "}
                              </Link>
                            </li>
                          </>
                        ) : (
                          <>
                            <li key={index}>{text}</li>
                          </>
                        )}
                      </>
                    );
                  })}
                </div>
              </Paper>
            ) : (
              <></>
            )}

            {showMore["arr_lemmas"] ? (
              <Paper className="sig_SignModal_PaperContent">
                <div className="sig_SignModal_PaperTitle">Sinónimos</div>
                <hr></hr>
                <div className="sig_SignModal_PaperBody">
                  {dataMore["arr_lemmas"].map((item,idx) => {
                    return (
                      <>
                        {" "}
                        { dialogPosition['lemma'] !== item ? <Chip className="sig_SignModal_LemmaChip" label={json_data_lemma[item]["label"]} onClick={handleClickChangeLemma(item)} /> : " "}
                        {" "}
                      </>
                    );
                  })}
                </div>
              </Paper>
            ) : (
              <></>
            )}

            {/* Relation between two or ore meanings */}
            {showMore["arr_relatedTo"] ? (
              <Paper className="sig_SignModal_PaperContent">
                <div className="sig_SignModal_PaperTitle">Términos relacionados</div>
                <hr></hr>
                <div className="sig_SignModal_PaperBody">
                  {dataMore["arr_relatedTo"].map((item, idx) => {
                    const lemma_relatedTo = json_data_meaning[item]["arr_lemmas"][0]
                    return (
                      <>
                        {" "}
                        { dialogPosition['lemma'] !== lemma_relatedTo ? <Chip className="sig_SignModal_LemmaChip" label={json_data_lemma[lemma_relatedTo]["label"]} onClick={handleClickChangeLemma(lemma_relatedTo)} /> : " "}
                        {" "}
                      </>
                    );
                  })}
                </div>
              </Paper>
            ) : (
              <></>
            )}
            
            {showMore["arr_equalTo"] ? (
              <Paper className="sig_SignModal_PaperContent">
                <div className="sig_SignModal_PaperTitle">Signos iguales</div>
                <hr></hr>
                <div className="sig_SignModal_PaperBody">
                  {dataMore["arr_equalTo"].map((item, idx) => {

                    let meaning_equalTo = ''
                    if (json_data_glosses[item]["arr_meanings"][0] !== undefined){
                      meaning_equalTo = json_data_glosses[item]["arr_meanings"][0]
                    }else{
                      meaning_equalTo = json_data_glosses[item]["arr_variants"][0]
                    }

                    const lemma_relatedTo = json_data_meaning[meaning_equalTo]["arr_lemmas"][0]
                    
                    return (

                      <>
                        {" "}
                        { dialogPosition['gloss'] !== item ? <Chip className="sig_SignModal_LemmaChip" label={json_data_lemma[lemma_relatedTo]["label"]} onClick={handleClickChangeLemmaByGloss(item)} /> : " "}
                        {" "}
                      </>

                    );
                  })}
                </div>
              </Paper>
            ) : (
              <></>
            )}

            {showMore["arr_similarTo"] ? (
              <Paper className="sig_SignModal_PaperContent">
                <div className="sig_SignModal_PaperTitle">Signos similares</div>
                <hr></hr>
                <div className="sig_SignModal_PaperBody">
                  {dataMore["arr_similarTo"].map((item, idx) => {
                    const meaning_equalTo = json_data_glosses[item]["arr_meanings"][0]
                    const lemma_relatedTo = json_data_meaning[meaning_equalTo]["arr_lemmas"][0]
                    return (
                      <>
                        {" "}
                        { dialogPosition['gloss'] !== item ? <Chip className="sig_SignModal_LemmaChip" label={json_data_lemma[lemma_relatedTo]["label"]} onClick={handleClickChangeLemmaByGloss(item)} /> : " "}
                        {" "}
                      </>

                    );
                  })}
                </div>
              </Paper>
            ) : (
              <></>
            )}
          </AccordionDetails>
        </Accordion>
      ) : (
        <></>
      )}
    </>
  );
}
